"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitDeleteWorkspaceLogoF = void 0;
var tslib_1 = require("tslib");
var createErrorAction_1 = require("./../../../actionCreators/createErrorAction");
var effects_1 = require("redux-saga/effects");
var storage_1 = require("firebase/storage");
var actions_1 = require("../../../constants/actions");
var getWorkspaceLogoStoragePath_1 = require("../../../utilities/get/getWorkspaceLogoStoragePath");
var storage_2 = require("firebase/storage");
var description = 'submitDeleteWorkspaceLogoF';
var submitDeleteWorkspaceLogoF = function () {
    var action, workspaceId, _a, originalPath, thumbPath, storageRef;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!1) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.take)([actions_1.SUBMIT_DELETE_FILE])];
            case 1:
                action = _b.sent();
                workspaceId = action.values.workspaceId;
                if (!workspaceId) return [3 /*break*/, 3];
                _a = (0, getWorkspaceLogoStoragePath_1.getWorkspaceLogoStoragePath)({
                    workspaceId: workspaceId,
                }), originalPath = _a.originalPath, thumbPath = _a.thumbPath;
                storageRef = (0, storage_2.ref)((0, storage_1.getStorage)());
                (0, storage_2.deleteObject)((0, storage_2.ref)(storageRef, originalPath)); // dont care if it fails
                (0, storage_2.deleteObject)((0, storage_2.ref)(storageRef, thumbPath)); // dont care if it fails
                return [4 /*yield*/, (0, effects_1.put)({
                        type: 'GET_WORKSPACE_LOGO_URL_SUCCESS',
                        description: description,
                        requestValues: {
                            workspaceId: workspaceId,
                        },
                        successValues: {
                            logoUrl: undefined,
                        },
                    })];
            case 2:
                _b.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, effects_1.put)((0, createErrorAction_1.createErrorAction)({
                    description: description,
                }))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [4 /*yield*/, (0, effects_1.put)({
                    type: actions_1.SUBMIT_DELETE_FILE_DONE,
                })];
            case 6:
                _b.sent();
                return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
exports.submitDeleteWorkspaceLogoF = submitDeleteWorkspaceLogoF;
